import React from "react";
import {
  GalleryFive,
  GalleryFour,
  GalleryOne,
  GallerySix,
  GalleryThree,
  GalleryTwo,
  HomeContactBG,
  ProductEight,
  ProductFive,
  ProductFour,
  ProductNine,
  ProductOne,
  ProductSeven,
  ProductSix,
  ProductThree,
  ProductTwo,
  VideoBG,
} from "../Images";
import { Link } from "react-router-dom";
import { ContactUsFooter } from "../Layouts";

const Product = () => {
  return (
    <>
      <div
        className="site-breadcrumb"
        style={{ backgroundImage: `url(${VideoBG})` }}
      >
        <div className="container">
          <h2 className="breadcrumb-title">Our Products</h2>
          <ul className="breadcrumb-menu">
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>/</li>
            <li className="active">Our Products</li>
          </ul>
        </div>
      </div>
      <div className="product-area py-120">
        <div className="container">
          <div className="row">
            {[
              {
                name: "FROZEN EEL",
                img: ProductOne,
                path: "products",
              },
              {
                name: "WHOLE CLEAN SQUID",
                img: ProductTwo,
                path: "products",
              },
              {
                name: "SEA CAUGHT SHRIMP",
                img: ProductThree,
                path: "products",
              },
              {
                name: "SEA CAUGHT SHRIMP",
                img: ProductFour,
                path: "products",
              },
              {
                name: "FROZEN SOLE FISH",
                img: ProductFive,
                path: "products",
              },
              {
                name: "FROZEN SLAB",
                img: ProductSix,
                path: "products",
              },
              {
                name: "FROZEN POMFRET",
                img: ProductSeven,
                path: "products",
              },
              {
                name: "POMFRET",
                img: ProductEight,
                path: "products",
              },
              {
                name: "BLANCHED VANNAMEI",
                img: ProductNine,
                path: "products",
              },
            ].map((item) => (
              <div className="col-lg-4 col-md-6 mb-5">
                <div className="portfolio-item">
                  <div className="portfolio-img">
                    <img className="img-fluid" src={item.img} alt="" />
                    <Link
                      className="popup-img portfolio-link"
                      to={`/${item.path}`}
                    >
                      <i className="fa fa-plus"></i>
                    </Link>
                  </div>
                  <div className="portfolio-content">
                    <div className="portfolio-content-info">
                      <small>{item.name}</small>
                    </div>
                    <Link to={`/${item.path}`} className="portfolio-arrow">
                      <i className="fa fa-arrow-right"></i>
                    </Link>
                  </div>
                </div>{" "}
              </div>
            ))}
          </div>
        </div>
      </div>
      <ContactUsFooter />
    </>
  );
};

export default Product;
